import gsap from "gsap";
import DefaultBlock from "/scripts/default/block";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { watchPreferredMotion } from "../../../../../utils/helpers/watchPreferredMotion";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

export default class UICheckbox extends DefaultBlock {
	init() {
		this.DOM = {
			mask: this.block.querySelector("#stroke-mask"),
			circle: this.block.querySelector("#circle"),
			circleGradient: this.block.querySelector("#circle circle:first-child"),
			strokeGradient: this.block.querySelector(
				"#stroke-gradient path:first-child"
			),
			button: this.block.querySelector("#ui-checkbox-btn"),
		};

		this.state = {
			active: true,
		};

		this.circleLightGradientUrl = this.block
			.querySelector("#circle-light circle:first-child")
			.getAttribute("fill");
		this.strokeLightGradientUrl = this.block
			.querySelector("#stroke-gradient-light circle:first-child")
			.getAttribute("stroke");
		this.circleNightGradientUrl = this.DOM.circleGradient.getAttribute("fill");
		this.strokeNightGradientUrl =
			this.DOM.strokeGradient.getAttribute("stroke");

		this.xTo = gsap.quickTo(this.DOM.circle, "x", {
			ease: "power3",
			duration: 0.3,
		});
		this.yTo = gsap.quickTo(this.DOM.circle, "y", {
			ease: "power3",
			duration: 0.3,
		});

		this.buttonWidth = this.DOM.button.offsetWidth;
		this.buttonHeight = this.DOM.button.offsetHeight;
		this.movement = 30;

		this.buildOn();
	}

	initEvents() {
		document.addEventListener("setLightMode", () => {
			this.DOM.circleGradient.setAttribute("fill", this.circleLightGradientUrl);
			this.DOM.strokeGradient.setAttribute(
				"stroke",
				this.strokeLightGradientUrl
			);
		});

		document.addEventListener("setNightMode", () => {
			this.DOM.circleGradient.setAttribute("fill", this.circleNightGradientUrl);
			this.DOM.strokeGradient.setAttribute(
				"stroke",
				this.strokeNightGradientUrl
			);
		});

		this.DOM.button.addEventListener("mouseenter", (e) => {
			gsap.to(this.DOM.button, {
				scale: 1.07,
				duration: 0.5,
				ease: "power4.out",
			});
		});

		this.DOM.button.addEventListener("mouseleave", (e) => {
			this.xTo(0);
			this.yTo(0);
			gsap.to(this.DOM.button, {
				scale: 1,
				duration: 0.5,
				ease: "power4.out",
			});
		});

		this.DOM.button.addEventListener("mousemove", (e) => {
			const { clientX, clientY } = e;
			const { left, top } = this.DOM.button.getBoundingClientRect();
			const relX = clientX - left;
			const relY = clientY - top;
			const x =
				((relX - this.buttonWidth / 2) / this.buttonWidth) * this.movement;
			const y =
				((relY - this.buttonHeight / 2) / this.buttonHeight) * this.movement;

			this.xTo(x);
			this.yTo(y);
		});

		this.DOM.button.addEventListener("click", () => {
			this.toggle();
		});
	}

	toggle() {
		gsap.to(this.DOM.circle, {
			scale: this.state.active ? 0 : 1,
			transformOrigin: "50% 50%",
			duration: 0.15,
			ease: this.state.active ? "back.in(1.5)" : "back.out(1.5)",
			onComplete: () => {
				this.state.active = !this.state.active;
			},
		});
	}

	buildOn() {
		gsap.set(this.block, { autoAlpha: 1 });

		watchPreferredMotion(() => {
			gsap.set(this.DOM.mask, { opacity: 1 });

			const buildOnTl = gsap.timeline({
				id: "checkbox-build-on",
				scrollTrigger: {
					trigger: this.block,
					start: "top 85%",
				},
			});

			buildOnTl
				.to(this.DOM.mask, {
					drawSVG: "0 0%",
					duration: 0.6,
					ease: "power3.inOut",
				})
				.from(this.DOM.circle, {
					scale: 0,
					transformOrigin: "50% 50%",
					duration: 0.3,
					ease: "back.out(1)",
				});

			// GSDevTools.create();
		});
	}
}
